import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { TrackEventsService } from './analytics/track-events.service';
import { TrackEventsServiceStub } from './analytics/track-events-stub.service';
import { AbstractTrackEventsService } from './analytics/abstract-track-events.service';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AbstractTrackEventsService,
      useClass: environment.production ? TrackEventsService : TrackEventsServiceStub,
    },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
  ],
};
